import * as React from 'react';
import { useFiltersContext } from '../../contexts/filters';
import { IPost } from '../../types';

interface IProps {
	post: IPost;
}

const BeforeAfter = ({ post }: IProps) => {
	const { setModalOpen, setModalPostDisplayed } = useFiltersContext();
	const handleOnClick = (postID: number) => {
		// pop modal and display correct slide
		if (setModalOpen) {
			setModalOpen(true);
		}
		if (setModalPostDisplayed) {
			setModalPostDisplayed(postID);
		}
	};

	return (
		<button className="card pfa-card-before-after" onClick={() => handleOnClick(post.ID)}>
			{!!post.before_image && (
				<figure
					className="pfa-card-before-after__before-figure"
					dangerouslySetInnerHTML={{ __html: post.before_image }}
				/>
			)}
			{!!post.after_image && (
				<figure
					className="pfa-card-before-after__after-figure"
					dangerouslySetInnerHTML={{ __html: post.after_image }}
				/>
			)}
			<span className="pfa-card-before-after__expand">
				<i className="icon-expand"></i>
			</span>
		</button>
	);
};

BeforeAfter.displayName = 'BeforeAfter';

export default BeforeAfter;
